import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../../product/services/product.service';

@Component({
  standalone: false,
  selector: 'lib-restriction-dialog',
  templateUrl: './restriction-dialog.component.html',
  styleUrls: ['./restriction-dialog.component.scss'],
})
export class RestrictionDialogComponent implements OnInit {
  prettyRestrictions: Record<string, Record<string, string[]>> = {};

  constructor(private productService: ProductService) {}

  ngOnInit() {
    this.prettyRestrictions = this.productService.getPrettyRestrictions();
  }
}
